import React, { useState, useEffect, useContext } from 'react'

// styles for page
import './styles.css'

// components for page
import api from '../../services/api';
import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'
import LargeCard from '../../components/largeCard/index.js'
import SmallCard from '../../components/smallCard/index.js'
import StoreContext from '../../components/storage/context'
import AlertCustom from '../../components/alertCustom/index.js'
import errorHandlerShow from '../../components/errorHandlerShow/index.js'
import CarouselNews from '../../components/carouselNews/index.js'
import LargeCardFake from '../../components/largeCardFake/index.js'
import LargeCardPlaceholder from '../../components/placeholders/largeCardPlaceholder/index.js';

// imagens
import perfume_deo_f from '../../assets/essencial_exclusivo_deo_parfum_feminino.png'
import essencial_deo_m from '../../assets/essencial_deo_parfum_masculino.png'
import essencial_oud_deo_f from '../../assets/essencial_oud_deo_parfum_feminino.png'
import polpa_hidratante_ekos_ucuuba from '../../assets/polpa_hidratante_ekos_ucuuba.png'


const Home = () => {
    const { token, pk_user, setToken } = useContext(StoreContext)

    const [loadApi, setLoadApi] = useState(false)
    const [products, setProducts] = useState([])
    const [showAlert, setShowAlert] = useState(false)
    const [productsMissing, setProductsMissing] = useState([])
    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});

    useEffect(() => {
        setLoadApi(true)
        api.get('services', {
            params: {'pk_user': pk_user},
            headers: {'Authorization': token}
        }).then(response => {
            setProducts(response.data)
            setLoadApi(false)

            // add fake large
            const amountMissing = 3 - response.data.length%3
            setProductsMissing(Array.from(Array(amountMissing), (_, i) => i+1))
        })
        .catch(error => {
            errorHandlerShow(error, setToken, setAlert, setShowAlert)
        })
    }, []);

    const about = [
        {
            'name': 'Time',
            'color': '#24574c',
            'image': perfume_deo_f,
            'link': 'https://wd5.myworkday.com/avon/d/inst/4547$166208/rel-task/2998$14648.htmld#opennodes=2500%249052%2C2500%249050&viewing=2500%249050',
            'external_link': true
        },
        {
            'name': 'Dúvidas',
            'color': '#447c64',
            'image': essencial_oud_deo_f,
            'link': '/faq',
            'external_link': false
        },
        {
            'name': 'Plataforma',
            'color': '#60bc88',
            'image': polpa_hidratante_ekos_ucuuba,
            'link': 'https://natura.atlassian.net/wiki/spaces/CAEEDD/pages/3089302074/Integration+Layer',
            'external_link': true
        }
    ]

    return (
        <div>
            <Header />

            <div className="home-container">
                <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

                <CarouselNews />

                <p className="home-title">Sobre CoeDados</p>

                <div className="home-container-about">
                    {about.map((item, index) => (
                        <SmallCard title={item.name} color={item.color} image={item.image} url={item.link} external_link={item.external_link} />
                    ))}
                </div>

                <p className="home-title">Nossos produtos</p>
                
                {loadApi ?
                    <div className="home-container-list">
                        {[1, 2, 3].map((item, index) => (
                            <LargeCardPlaceholder  />
                        ))}
                    </div>
                :
                    <div className="home-container-list">
                        {products.map((item, index) => (
                            <LargeCard id={item.pk_service} name={item.type_service} url={item.link_service} image={item.image_name} />
                        ))}
                        {/* add missing card */}
                        {productsMissing.map((item, index) => (
                            <LargeCardFake id={index} />
                        ))}
                    </div>
                }
            </div>

            <Footer />

        </div>
    );
}

export default Home;
